module.exports = __webpack_public_path__ + "img/Edson.bd163426.jpg";